import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import Reveal from "../components/kedve/Reveal";
import { ACCELERATORS } from "../data/kedve";

export default function Accelerators() {
  return (
    <div data-testid="page-accelerators" className="text-black">
      {/* HERO */}
      <section className="pt-36 pb-24 md:pb-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="eyebrow opacity-60">Career Accelerators</div>
          <h1 className="mt-8 font-serif text-6xl md:text-8xl lg:text-[10rem] leading-[0.9] tracking-tightest">
            Learn. Practice.<br />
            Apply. <span className="italic">Transform.</span>
          </h1>
          <div className="mt-14 grid md:grid-cols-12 gap-10">
            <p className="md:col-span-6 text-lg leading-relaxed opacity-70">
              Eight signature programs. Each one shaped by the professionals who have already done the work, and taught by them. Choose the one that meets you now.
            </p>
            <div className="md:col-span-4 md:col-start-9 flex flex-col gap-3 md:items-end">
              <Link to="/apply" data-testid="accel-apply" className="inline-flex items-center gap-2 bg-black text-white rounded-full px-7 py-4 text-sm tracking-wide hover:bg-black/85 transition">
                Apply <ArrowUpRight className="w-4 h-4" />
              </Link>
              <Link to="/philosophy" className="inline-flex items-center gap-2 border border-black rounded-full px-7 py-4 text-sm tracking-wide hover:bg-black hover:text-white transition">
                Our Philosophy
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* PROGRAMS TABLE */}
      <section className="pb-28 md:pb-40">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="border-t border-black" data-testid="accelerators-table">
            <div className="grid grid-cols-12 py-5 border-b border-black">
              <div className="col-span-12 md:col-span-4 eyebrow opacity-60">Signature Program</div>
              <div className="hidden md:block col-span-8 eyebrow opacity-60">Career Outcome</div>
            </div>

            {ACCELERATORS.map((a, i) => (
              <Reveal key={a.id} delay={i * 40}>
                <div
                  className="grid grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-b border-black/15 items-baseline group"
                  data-testid={`program-${a.id}`}
                >
                  <div className="col-span-12 md:col-span-4">
                    <h3 className="font-serif text-3xl md:text-4xl tracking-tightest leading-tight group-hover:italic transition-all">
                      {a.title}
                    </h3>
                  </div>
                  <div className="col-span-12 md:col-span-8 text-lg leading-relaxed opacity-80">
                    {a.outcome}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* METHOD */}
      <section className="py-28 md:py-40 bg-neutral-50">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <div className="eyebrow opacity-60">The Method</div>
              <h2 className="mt-6 font-serif text-5xl md:text-6xl tracking-tightest leading-[0.95]">Practice is the<br /><span className="italic">only teacher.</span></h2>
            </div>
            <div className="md:col-span-6 md:col-start-7 space-y-8 text-lg leading-relaxed opacity-80">
              <p>Every program opens with a live rehearsal, not a lecture. You practise the moment before you understand the theory behind it.</p>
              <p>What you did is then reviewed, together. Not to grade you, but to shape your next attempt. Iteration is the pedagogy.</p>
              <p>By the last week, you have not learned about business. You have practised it, in the room, in front of people who have done it.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CLOSING CTA */}
      <section className="py-28 md:py-40">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-5xl md:text-7xl tracking-tightest leading-[0.9]">
            Choose the program<br /><span className="italic">that meets you now.</span>
          </h2>
          <Link to="/apply" data-testid="accel-closing-apply" className="mt-10 inline-flex items-center gap-2 bg-black text-white rounded-full px-8 py-4 text-sm tracking-wide hover:bg-black/85 transition">
            Begin your application <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
